
import { CommonData } from "../../../datastructures/gamestate/gameData";
import { GameRoundMetaData } from "../../APIModels/models";
import { EmulationBtn } from "./emulationBtns";


export class EmulationSelectorList {
  private parent = new PIXI.Container();
  private btnsList: EmulationBtn[] = [];
  private activeGameData:CommonData;
  private emulationDataListCopy:GameRoundMetaData[]=[];
  private isVisible:boolean=true;//default is visibile;

  ///-pages
  private maxBtnPerPage:number=8;//max bns per page
  private currentPage:number=0;
  private totalPages:number=0;
  private navBtnContainer = new PIXI.Container();
  private btnUp= new PIXI.Sprite(PIXI.Texture.fromFrame('btn_Play.png'));
  private btnDown= new PIXI.Sprite(PIXI.Texture.fromFrame('btn_Play.png'));
  private btnsPerpage:EmulationBtn[][]=[[]];

  constructor(parent: PIXI.Container,activeGameData:CommonData, emulationDataList: GameRoundMetaData[]) {
    this.activeGameData=activeGameData;
    this.emulationDataListCopy=emulationDataList;
    this.totalPages=Math.ceil(this.emulationDataListCopy.length/this.maxBtnPerPage);
    parent.addChild(this.parent);
    this.parent.x=35;
    // this.createMainBG();
    this.createBtns();
    // this.onResize();
    this.createNavBtns();
    this.loadSelectedPage();
  }
  public setIsWatingResponse=(bool:boolean):void=>
  {
    for (let i = 0; i < this.btnsList.length; i++) {
      this.btnsList[i].setIsWatingResponse(bool);
      
    }
  }
  private createNavBtns=():void=>
  {   

    // this.navBtnContainer.addChild(this.btnBG);

    if(this.totalPages>1)
    {
      this.parent.addChild(this.navBtnContainer);
      this.navBtnContainer.addChild(this.btnUp);
      this.navBtnContainer.addChild(this.btnDown);
      this.btnUp.on('pointertap', () => this.goToNextPage(false));
      this.btnDown.on('pointertap', () => this.goToNextPage(true));
      
      this.btnUp.x=0;
      this.btnUp.y=0;
      this.btnDown.x=  this.btnUp.x+200;
      this.btnDown.y=  this.btnDown.y;  
 

      this.btnUp.anchor.set(.5);
      this.btnDown.anchor.set(.5);
      this.btnUp.rotation=Math.PI;

 
      this.btnDown.rotation=0;
      this.enableNavBtns(true);


    }
    this.navBtnContainer.x=-100+400;
    this.navBtnContainer.y=850;
  
  }
  public setClickable=(bool:boolean):void=>
  {
    //set the visible btn to be clickable or not;
    this.disableAllBtns();
    if(bool)
    { this.enableVisibleBtn();}
    this.enableNavBtns(bool)
  }
  private goToNextPage=(bool:boolean):void=>
  {
  if(bool){
    this.currentPage++
    if(this.currentPage>this.totalPages-1){this.currentPage=0;}
  }
  else {
    this.currentPage--;
    if(this.currentPage<0){this.currentPage=this.totalPages-1};    
  }
  this.loadSelectedPage();

  }

  private loadSelectedPage=():void=>
  {
    // console.log('load page',this.currentPage);
    this.hideAll();
    this.disableAllBtns()
    //-enable only the btns that fits inside page
    for (let i = 0; i < this.btnsPerpage[this.currentPage].length; i++) {
        this.btnsPerpage[this.currentPage][i].setVisible(true);      
    }
    if(this.activeGameData.emulationMode.getISVisible())
    {
      this.enableVisibleBtn();
    }
   
  }
  
    private enableVisibleBtn=():void=>
    {
      // if(this.activeGameData.replay.getIsClickable)
      // {
        for (let i = 0; i < this.btnsPerpage[this.currentPage].length; i++) {
          this.btnsPerpage[this.currentPage][i].enableBtnMode(true);  
  
      // }
      }
    } 
 
private disableAllBtns=():void=>
{
  for (let i = 0; i < this.btnsList.length; i++) {
    this.btnsList[i].enableBtnMode(false);
  }
}
  private hideAll=():void=>
{
  for (let i = 0; i < this.btnsList.length; i++) {
    this.btnsList[i].setVisible(false);    
  }
}
private createBtns = (): void => {
  let col = 0;
  let row = 0;
  this.btnsPerpage = [[]];
  for (let i = 0; i < this.emulationDataListCopy.length; i++) {
    this.btnsList[i] = new EmulationBtn(
      this.parent,
      this.activeGameData,this.emulationDataListCopy[i].id+': '+
      this.emulationDataListCopy[i].featureName,
      i
    );

    // Set position
    let newPosition = { x: 100, y: 100+row * 85 };
    this.btnsList[i].setPosition(newPosition);
    this.btnsPerpage[col][row] = this.btnsList[i];
    row++;

    if (row > this.maxBtnPerPage - 1) {
      row = 0;
      col++;
      if (col >= this.btnsPerpage.length) {
        this.btnsPerpage.push([]);
      }
    }
  }
  this.isVisible = true;
}

  public toggle=():void=>
  
  {
    if(this.isVisible)
    {

      //hide
      this.isVisible=false;

    }
    else
    {
      //show
      this.isVisible=true;
    }
    this.setVisible(this.isVisible);
  }
  private setVisible=(bool:boolean):void=>
  {
    for (let i = 0; i < this.btnsList.length; i++) {
      this.btnsList[i].enableBtnMode(bool);
      this.btnsList[i].setVisible(bool);
    }
  
  }
  public enableNavBtns=(bool:boolean):void=>
  {
    this.btnDown.interactive=bool;
    this.btnDown.buttonMode=bool;
    this.btnUp.interactive=bool;
    this.btnUp.buttonMode=bool;
  }
  // public onResize=():void=>
  // {
  //   let screenRatio = window.innerHeight / window.innerWidth;
  //   let isPortraitMode =    this.activeGameData.playOnPortrait &&    window.matchMedia("(orientation: portrait)").matches &&
  //   this.activeGameData.isMobile &&
  //   screenRatio >= this.activeGameData.minRatioForPortraitPlay;
  //   this.navBtnContainer.rotation=(90*Math.PI/180);
  //   if (isPortraitMode) 
  //   {
  //     this.parent.scale.set(2);
  //     this.navBtnContainer.scale.set(.80);
  //     this.navBtnContainer.x=780;
  //     this.navBtnContainer.y=805;
  //   }
  //   else
  //   {
  //     this.parent.scale.set(1);
  //     // this.navBtnContainer.scale.set(1);
  //     this.navBtnContainer.scale.set(.80);
  //     this.navBtnContainer.x=500;
  //     this.navBtnContainer.y=800;
  //   }
  // }
  public setLandscapeMode=(isLandScape:boolean):void=>
  {
    
    if (!isLandScape) 
    {
      this.parent.scale.set(2);
      this.navBtnContainer.scale.set(.80);
      this.navBtnContainer.x=780;
      this.navBtnContainer.y=805;
    }
    else
    {
      this.parent.scale.set(1);
      // this.navBtnContainer.scale.set(1);
      this.navBtnContainer.scale.set(.80);
      this.navBtnContainer.x=500;
      this.navBtnContainer.y=800;
    }
  }
}


